import * as React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { JRCTypography } from '../JRCTypography/JRCTypography';

type EmptySpaceBgColor = 'sandLight' | 'sky15' | 'transparent';
type Alignment = React.CSSProperties['justifyContent'];

const Container = styled.div<{ bgColor: EmptySpaceBgColor }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    padding: 32px;
    background: ${(props) => (props.bgColor === 'transparent' ? props.bgColor : props.theme.color[props.bgColor])};
`;
const Aligned = styled.div<{ alignment: Alignment }>`
    display: flex;
    flex-direction: column;
    justify-content: ${({ alignment }) => alignment};
    align-items: center;
    flex: 1;
`;
const Description = styled.div`
    white-space: pre-line;
    text-align: center;
`;
const Actions = styled.div`
    margin: 24px;
`;

export type JRCEmptySpaceProps = {
    img?: string;
    imgAlt?: string;
    title: string;
    description?: string;
    actions?: React.ReactChild;
    bgColor?: EmptySpaceBgColor;
    alignment?: Alignment;
};

export const JRCEmptySpace: React.FC<JRCEmptySpaceProps> = ({
    img,
    imgAlt,
    title,
    description,
    actions,
    bgColor = 'sandLight',
    alignment = 'center',
}) => {
    const intl = useIntl();
    const titleText = intl.formatMessage({ id: title });
    const descriptionText = description ? intl.formatMessage({ id: description }) : undefined;
    return (
        <Container bgColor={bgColor}>
            <Aligned alignment={alignment}>
                {img && (
                    <img
                        src={img}
                        alt={imgAlt ?? titleText}
                        style={{ width: '100%', maxWidth: '500px', marginBottom: '24px' }}
                    />
                )}
                <JRCTypography variant={'h1'} size={'xxxl'} margin={'0 0 8px 0'} textAlign="center">
                    {titleText}
                </JRCTypography>
                {descriptionText && <Description>{descriptionText}</Description>}
                {actions && <Actions>{actions}</Actions>}
            </Aligned>
        </Container>
    );
};
